import { Flex, Input, Text } from '@tonic-one/react';
import React, { forwardRef, useImperativeHandle } from 'react';
import { TextInputFormikProps } from './type';
import { FormInput, FormLabel, FormTextarea } from '../FormComponent';
import { useField } from 'formik';
export const InlineError = (props: any) => (
  <Text fontSize="sm" lineHeight="sm" color="red:50" {...props} />
);
const InputFormik = forwardRef<Input, TextInputFormikProps>(
  ({ name, label, required, type }, ref) => {
    const [field, meta, helpers] = useField(name);
    const { value, onChange } = field;
    const { error, touched } = meta;
    const inputRef = React.useRef<HTMLInputElement | null>(null);
    useImperativeHandle(ref, () => ({
      ...meta,
      ...helpers,
      ...inputRef.current,
    }));
    return (
      <Flex alignItems="flex-start">
        <FormLabel label={label} required={required} />
        {type === 'textArea' ? (
          <Flex direction="column">
            <FormTextarea
              ref={inputRef}
              value={value}
              onChange={onChange}
              name={name}
            />
            {error && touched && <InlineError>{error}</InlineError>}
          </Flex>
        ) : (
          <Flex direction="column">
            <FormInput
              ref={inputRef}
              value={value}
              onChange={onChange}
              name={name}
              error={!!error && touched}
            />
            {error && touched && <InlineError>{error}</InlineError>}
          </Flex>
        )}
      </Flex>
    );
  }
);

export default InputFormik;
